module.exports = __webpack_public_path__ + "fonts/IBMPlexSans-Bold.92e83f7.woff2";